import { progress, progressBar, label_progress, label_progressBar, category } from './consts';

export default function(editor, opts = {}) {
  const bm = editor.BlockManager;

  if (opts.blocks.indexOf(progress) >= 0) {
    bm.add(progress, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="32" height="50" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1792 1408"><path d="M1024 1280h640v-128h-640v128zM640 768h1024V640H640v128zm640-512h384V128h-384v128zm512 832v256q0 26-19 45t-45 19H64q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 832V576q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-512v256q0 26-19 45t-45 19H64q-26 0-45-19T0 320V64q0-26 19-45T64 0h1664q26 0 45 19t19 45z" fill="#c3cfe9"/></svg>
      <div>${label_progressBar}</div>`,
      category: category,
      content: {
        type: progress,
        tagName: 'div',
        classes: [progress],
        attributes: {
          role: progress,
        },
      },
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${label_progressBar}?"></i>
        </a>
      </span>
    `,
    });
  }
}
